var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
export default function ErrorIcon(_a) {
    var className = _a.className;
    return (_jsx("div", __assign({ className: className }, { children: _jsx("svg", __assign({ width: 84, height: 84, viewBox: "0 0 84 84", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M42 26v16m0 16h.04M82 42c0 22.091-17.909 40-40 40S2 64.091 2 42 19.909 2 42 2s40 17.909 40 40z", stroke: "#8C1D0A", strokeWidth: 4, strokeLinecap: "round", strokeLinejoin: "round" }) })) })));
}
